import React from 'react'
import ButtonComponent from '../../components/ButtonComponent';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy"><ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage}/></div>
            <div className="container mt-2 mb-5 py-4 privacy-policy">
                <h3 className='fw-bold'>Privacy Policy</h3>
                <p> Effective Date: 1st May 2025</p>
                <p>
                    Welcome to Curry King (Private) Limited ("Curry King", "we", "our", or "us"). We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our website, use our services, or interact with us.
                </p>
                <p>By using our website or services, you consent to the practices described in this Privacy Policy.</p>
                <hr />
                <h5 className='fw-bold'>1. Information We Collect</h5>
                <p>We may collect the following types of information:</p>
                <ul>
                    <li>
                        <strong>Personal Information:</strong>
                        Name, email address, phone number, delivery address, payment details, and other information you provide when placing an order or registering an account.
                    </li>
                    <li>
                        <strong>Device and Usage Information:</strong>
                        IP address, browser type, operating system, access times, and pages viewed.
                    </li>
                    <li><strong>Cookies and Tracking Technologies:</strong> We use cookies and similar technologies to enhance your experience, analyze usage, and assist in marketing efforts.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>2. How We Use Your Information</h5>
                <p>We use the information we collect to:</p>
                <ul>
                    <li>
                        Process and fulfill your orders.
                    </li>
                    <li>
                        Communicate with you regarding your orders, account, and customer service inquiries.
                    </li>
                    <li>Send marketing communications (only if you have opted in).
                    </li>
                    <li>
                        Improve our website, services, and overall customer experience.
                    </li>
                    <li>Comply with legal obligations.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>3. Sharing Your Information</h5>
                <p>We may share your information with:</p>
                <ul>
                    <li>
                        <strong>Service Providers:</strong>
                        Third-party vendors who perform services on our behalf (e.g., payment processing, delivery services, IT support).
                    </li>
                    <li>
                        <strong>Legal Requirements:</strong>
                        If required by law, regulation, or legal process.
                    </li>
                    <li><strong>Business Transfers:</strong> In connection with any merger, sale of company assets, financing, or acquisition.
                    </li>
                </ul>
                <p>We do not sell, rent, or trade your personal information to third parties.</p>
                <hr />
                <h5 className='fw-bold'>4. Your Rights and Choices</h5>
                <p>You have the right to:</p>
                <ul>
                    <li>
                        Access, update, or delete your personal information.
                    </li>
                    <li>
                        Opt-out of receiving marketing communications.
                    </li>
                    <li>Request the restriction or objection to certain data processing activities.
                    </li>
                </ul>
                <p>To exercise your rights, please contact us using the details provided below.
                </p>
                <hr />
                <h5 className='fw-bold'>5. Data Security</h5>
                <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or method of electronic storage is 100% secure.</p>
                <hr />
                <h5 className='fw-bold'>6. Retention of Your Information</h5>
                <p>We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required by law.</p>
                <hr />
                <h5 className='fw-bold'>7. Children's Privacy</h5>
                <p>Our food services are available for children; however, all orders must be placed by adults aged 18 and above. We do not knowingly collect personal information directly from children.</p>
                <hr />
                <h5 className='fw-bold'>8. Changes to This Privacy Policy</h5>
                <p>We may update this Privacy Policy from time to time. We encourage you to review this policy periodically for any changes. Your continued use of our services after any changes indicates your acceptance of the updated Privacy Policy.</p>
                <hr />
                <h5 className='fw-bold'>9. Contact Us</h5>
                <p>If you have any questions about this Privacy Policy or our privacy practices, please contact us at:</p>
                Curry King (Private) Limited
                <br />
                55/2 Vauxhall Lane,
                <br />
                Colombo 2, Sri Lanka
                <br />
                Email: regulatory@curryking.lk
            </div>
        </>
    )
}

export default PrivacyPolicy;